import builder from '../builder';
import SocialMediaTwitter from '../../streamline-icons/bold/social-media-twitter.svg';

export default builder('IconSocialMediaTwitterBold', SocialMediaTwitter);
